/** Max people invitees before free/busy is skipped (single POST, no chunking). */
export var MAX_INVITEES_FOR_AVAILABILITY = 50;
/**
 * Max length of free/busy `from`/`to` window (API: "may not exceed P2D").
 * Product rule: do not check invitee conflicts when the event span is > 1 day.
 */
export var MAX_AVAILABILITY_BOUND_MS = 24 * 60 * 60 * 1000;
export var AVAILABILITY_DEBOUNCE_MS = 300;
export var AVAILABILITY_RECURRING_DEBOUNCE_MS = 600;
export var MAX_DISPLAY_CONFLICT_DATES = 5;
